export function UploadGuidelines() {
  return (
    <div className="mt-8 bg-blue-50 dark:bg-[#5B5353]/30 rounded-lg p-6">
      <h3 className="text-lg font-semibold text-blue-900 dark:text-[#FFF8F9] mb-3">
        Report Guidelines
      </h3>
      <ul className="space-y-2 text-sm text-blue-800 dark:text-[#FFF1F3]">
        <li className="flex items-start">
          <svg
            className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          <div className="flex-1">
            <strong>Search Reports:</strong> Walmart Connect Ad Center →
            Sponsored Search → Reports → Custom Report
            <ul className="mt-2 ml-4 space-y-1 text-xs">
              <li>
                <strong>Filter By:</strong> Current Month
              </li>
              <li>
                <strong>Split:</strong> Date (Day), Campaign Name (limit 10)
              </li>
              <li>
                <strong>Measure:</strong> Ad Spend, Total Sales Rev. - 14 Day,
                Advertised SKU Sales. - 14 Day, Impressions, Clicks, Total Units
                Sold - 14 Day, Advertised SKU Units (#) 14 Day, New-to-brand Units
                (#) - 14 Days, New-to-Brand Sales - 14 Days
              </li>
            </ul>
          </div>
        </li>
        <li className="flex items-start">
          <svg
            className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          <div className="flex-1">
            <strong>Onsite Reports:</strong> Walmart Connect Ad Center → Display
            Advertising → Reports → Onsite Display Daily → Select Timeframe →
            Export Metrics
          </div>
        </li>
        <li className="flex items-start">
          <svg
            className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          <span>
            Reports should be month-to-date and uploaded weekly for best results
          </span>
        </li>
        <li className="flex items-start">
          <svg
            className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          <span>
            Campaign names must follow the format:
            Brand_Product_AdType_Retailer_Period_OrderID
          </span>
        </li>
      </ul>

      <div className="mt-4 pt-4 border-t border-blue-200 dark:border-[#5B5353]">
        <div className="space-y-2">
          <a
            href="https://www.loom.com/share/5a6e7f6c312e44fab9d8dca79ce64304?sid=66ae51f6-365a-4535-9087-795f70dee760"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-sm font-medium text-blue-700 dark:text-[#FFF1F3] hover:text-blue-800 dark:hover:text-[#FFF8F9] transition-colors"
          >
            <svg
              className="h-5 w-5 mr-2"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
            </svg>
            Watch video tutorial: How to export Search reports from WMC
          </a>
          <br />
          <a
            href="https://www.loom.com/share/d3dce6225fd1490895d644238236972f?sid=ce968108-064f-4cb0-89aa-fd07b96f551f"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-sm font-medium text-blue-700 dark:text-[#FFF1F3] hover:text-blue-800 dark:hover:text-[#FFF8F9] transition-colors"
          >
            <svg
              className="h-5 w-5 mr-2"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
            </svg>
            Watch video tutorial: How to export Onsite reports from WMC
          </a>
        </div>
      </div>
    </div>
  );
}
